export default __webpack_public_path__ + "static/media/corner_right.079cd4f3.png";